import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL;

const getAllSurplusSales = async (params) => {
  const response = await axios.get(`${API_URL}surplus-sales`, {
    params,
    withCredentials: true,
  });
  return response.data;
};

const getSurplusSaleDetails = async (id) => {
  const response = await axios.get(`${API_URL}surplus-sales/${id}`, {
    withCredentials: true,
  });
  return response.data;
};

const addSurplusSale = async (data) => {
  const response = await axios.post(`${API_URL}surplus-sales`, data, {
    withCredentials: true,
  });
  return response.data;
};

const updateSurplusSale = async ({ id, data }) => {
  const response = await axios.put(`${API_URL}surplus-sales/${id}`, data, {
    withCredentials: true,
  });
  return response.data;
};

const deleteSurplusSale = async (id) => {
  const response = await axios.delete(`${API_URL}surplus-sales/${id}`, {
    withCredentials: true,
  });
  return response.data;
};

const surplusSalesService = {
  getAllSurplusSales,
  getSurplusSaleDetails,
  addSurplusSale,
  updateSurplusSale,
  deleteSurplusSale,
};

export default surplusSalesService;
